"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TERM = exports.ErrorMessages = void 0;
const errorMessages_enum_1 = require("./errorMessages.enum");
Object.defineProperty(exports, "ErrorMessages", { enumerable: true, get: function () { return errorMessages_enum_1.ErrorMessages; } });
var term_enum_1 = require("./term.enum");
Object.defineProperty(exports, "TERM", { enumerable: true, get: function () { return term_enum_1.TERM; } });
